import type { MutationFunction } from "@tanstack/react-query";
import { createMutation } from "react-query-kit";

import type { IPickDelete } from "../../types";
import { useGetAllUser } from "../getAll";
import { useGetUser } from "../get";

import type { IUsersAvatar } from "./routeType";

import { getApi } from "@/api/apiPath";
import { axiosClient, queryClient } from "@/api/clients";

const { getPath } = getApi("users.avatar.delete");

type IExtractedRouteType = IUsersAvatar["userAvatarSingleDelete"];

export type IDeleteUserAvatar = IPickDelete<IExtractedRouteType>;

const deleteUserAvatar: MutationFunction<
  IDeleteUserAvatar["response"],
  IDeleteUserAvatar["variables"]
> = ({ userId }) => {
  return axiosClient.delete(getPath({ userId }));
};

export const useDeleteUserAvatar = createMutation({
  mutationFn: deleteUserAvatar,
  onSuccess: (_, { userId }) => {
    queryClient.invalidateQueries({ queryKey: useGetAllUser.getKey() });
    queryClient.invalidateQueries({ queryKey: useGetUser.getKey({ userId }) });
  },
});
